import React from 'react';

export default function NavigationGroup(props) {
  const { children } = props;

  return (
    <div className="px-8 space-y-3">
      {children}
    </div>
  );
}
